const fetchElastic = async (indexName, body) => {
  try {
    const response = await fetch(`${process.env.GATSBY_ELASTIC_ES_URL}/${indexName}/_search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `ApiKey ${process.env.GATSBY_ELASTIC_API_KEY}`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch filters: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error searching Elasticsearch:', error);
  }
};

export default fetchElastic;
